import TextInput from 'components/input-field/TextInput';
import Loader from 'components/loader/Loader';
import React, { Component } from 'react'
import { Form, Formik } from 'formik';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SelectInput from 'components/input-field/SelectInput';
import SaveButton from 'components/buttons/SaveButton';
import { HairTestReportRes, HairTestReportTodo } from 'redux/slice/admin/text-report/hair-report/HairReport';
import { toast, ToastContainer } from 'react-toastify';
import { HairTestSchema } from './Validation';

class HairTestReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            dataRes: '',
            values: {
                hair_location: '',
                fungal_typ: '',
                structure_typ: '',
                metal_typ: '',
                hair_color: '',
                metal_concetration: '',
                keratin_presence: '',
                protein_level: '',
                asp: '',
                hmp: '',

            }
        };
    }


    hairLocation = [
        { "value": 'scalp', "label": "Scalp" },
        { "value": 'beard', "label": "Beard" },
        { "value": 'chest', "label": "Chest" },
        { "value": 'arm', "label": "Arm" },
        { "value": 'leg', "label": "Leg" },
    ]

    fungalType = [
        { "value": 'None', "label": "None" },
        { "value": 'Dermatophytes', "label": "Dermatophytes" },
        { "value": 'Candida', "label": "Candida" },
    ]

    structureType = [
        { "value": 'None', "label": "None" },
        { "value": 'Shaft Fracture', "label": "Shaft Fracture" },
        { "value": 'Trichorrhexis Nodosa', "label": "Trichorrhexis Nodosa" },
    ]
    metalType = [
        { "value": 'None', "label": "None" },
        { "value": 'Lead', "label": "Lead" },
        { "value": 'Mercury', "label": "Mercury" },
        { "value": 'Cadmium', "label": "Cadmium" },
    ]
    hairColor = [
        { "value": 'black', "label": "Black" },
        { "value": 'brown', "label": "Brown" },
        { "value": 'blonde', "label": "Blonde" },
        { "value": 'red', "label": "Red" },
        { "value": 'grey', "label": "Grey" },

    ]



    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        console.log(values)
        dispatch(HairTestReportTodo(values)).then(() => this.add_res());
    }

    add_res = () => {
        if (HairTestReportRes?.success) {
            toast.success(HairTestReportRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false, dataRes: HairTestReportRes?.data, });


        } else {
            toast.error(HairTestReportRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
            this.state({ dataRes: '' })
        }
    }


    render() {

        return (
            <>
                <div className="page-content">
                    <div className="container-fluid">
                        <h4 className="mb-0 font-size-18">Hair Analysis Prediction</h4>
                        <div className="row">
                            <div className="col-md-12">
                                <div className='form_layout'>
                                    {/* {this.state.spiner ?
                                        <div className='d-flex justify-content-center p-5'>
                                            <Loader />
                                        </div> : */}

                                        <Formik
                                            initialValues={this.state.values}
                                            validationSchema={HairTestSchema}
                                            onSubmit={this.handleSubmit}
                                        >
                                            {({
                                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                                <Form >
                                                    <div className="row">
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Hair Sample Location'
                                                                disabled={false}
                                                                options={this.hairLocation}
                                                                name='hair_location'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('hair_location', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.hair_location && touched.hair_location ? (<span className='text-danger form_label' >{errors.hair_location}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Fungal Type'
                                                                disabled={false}
                                                                options={this.fungalType}
                                                                name='fungal_typ'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('fungal_typ', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.fungal_typ && touched.fungal_typ ? (<span className='text-danger form_label' >{errors.fungal_typ}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Structure Type'
                                                                disabled={false}
                                                                options={this.structureType}
                                                                name='structure_typ'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('structure_typ', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.structure_typ && touched.structure_typ ? (<span className='text-danger form_label' >{errors.structure_typ}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Metal Type'
                                                                disabled={false}
                                                                options={this.metalType}
                                                                name='metal_typ'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('metal_typ', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.metal_typ && touched.metal_typ ? (<span className='text-danger form_label' >{errors.metal_typ}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Hair Color'
                                                                disabled={false}
                                                                options={this.hairColor}
                                                                name='hair_color'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('hair_color', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.hair_color && touched.hair_color ? (<span className='text-danger form_label' >{errors.hair_color}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Metal Concentration (0-50)'
                                                                placeholder=''
                                                                name='metal_concetration'
                                                                value={values.metal_concetration || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.metal_concetration && touched.metal_concetration ? (<span className='text-danger form_label' >{errors.metal_concetration}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Keratin Presence (0 or 1)'
                                                                placeholder=''
                                                                name='keratin_presence'
                                                                value={values.keratin_presence || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.keratin_presence && touched.keratin_presence ? (<span className='text-danger form_label' >{errors.keratin_presence}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Protein Level (0.1-100.0)'
                                                                placeholder=''
                                                                name='protein_level'
                                                                value={values.protein_level || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.protein_level && touched.protein_level ? (<span className='text-danger form_label' >{errors.protein_level}</span>) : null}
                                                            />
                                                        </Col>

                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Abnormal Structure Presence (0 or 1)'
                                                                placeholder=''
                                                                name='asp'
                                                                value={values.asp || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.asp && touched.asp ? (<span className='text-danger form_label' >{errors.asp}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Heavy Metals Presence (0 or 1)'
                                                                placeholder=''
                                                                name='hmp'
                                                                value={values.hmp || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.hmp && touched.hmp ? (<span className='text-danger form_label' >{errors.hmp}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='12' className=' d-flex justify-content-end'>
                                                            {/* <SaveButton name={'Predict'} /> */}
                                                            <button className="add_btn ps-3 pe-3 "  type="submit" disabled={this.state?.spiner ? true : false} >
                                                        {this.state?.spiner ? <>  <span className='ps-1'>Loading....</span> <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                        </> : <span >  PREDICT</span>}
                                                    </button>
                                                        </Col>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    {/* } */}
                                </div>
                            </div>
                            {this.state.dataRes ? (
                                <div className='row d-flex justify-content-center'>
                                    <div className="col-md-6">
                                        <div className="predit_res">
                                            <h3 className={this.state.dataRes?.prediction_result === "Positive for fungal presence" ? 'positive' : 'negative'}>{this.state.dataRes?.prediction_result}</h3>
                                        </div>
                                    </div>
                                </div>

                            ) : null}
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </>
        )
    }
}

export default connect()(withRouter(HairTestReport));
